import React from 'react';
// import CKEditor from "react-ckeditor-component";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PropTypes from 'prop-types';


const Editor = ({onChange, content, placeholder, disabled,   
  minHeight = '124px',
  maxHeight = '250px',
  backgroundColor = '#fff',
  borderColor = '#bdbdbd',
  color='#184a61'}) => {
  if (content === null) {
    return null
  }

  const finalTextColor = disabled ? '#BDBDBD' : color;

  return (
    <CKEditor
      data={content}
      // events={{
      //   "change": onChange
      // }}
      onChange={(evt,editor)=>onChange(editor)}
      editor={ ClassicEditor }
      config={{
        placeholder: placeholder || "Write description here...",
        isReadOnly: disabled,
        toolbar: {
          items: [
            'undo',
            'redo',
            'heading',
            'bold',
            'italic',
            'bulletedList',
            'numberedList',
            'link'
          ],
        },
        extraPlugins: [(editor) => {
          editor.on('ready', () => {
            editor.editing.view.change((writer) => {
              const root = editor.editing.view.document.getRoot();
              writer.setStyle(
                'padding-left', '12px',
                editor.editing.view.document.getRoot()
              );
              writer.setStyle('min-height', minHeight, root);
              writer.setStyle('max-height', maxHeight, root);
              writer.setStyle('background-color', backgroundColor, root);
              writer.setStyle('border-color', borderColor, root);
              writer.setStyle('padding', '8px 12px', root);
              writer.setStyle('border-width', '1px', root);
              writer.setStyle('border-style', 'solid', root);
              writer.setStyle('border-radius', '0px 0px 4px 4px', root);
              writer.setStyle('box-sizing', 'border-box', root);
              writer.setStyle('color', finalTextColor, root);
              // 2. Style the toolbar panel
              // 2. Style the toolbar container (.ck-toolbar)
              const toolbarEl = editor.ui.view.toolbar.element;
              if (toolbarEl && toolbarEl.classList.contains('ck-toolbar')) {
                toolbarEl.style.backgroundColor = backgroundColor;
                toolbarEl.style.borderRadius = '4px 4px 0 0'; // optional
              }
            });
          });
        }]

      }}
      disabled={disabled}

    />
  )
};

Editor.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  minHeight:PropTypes.string,
  maxHeight:PropTypes.string,
  backgroundColor:PropTypes.string,
  borderColor:PropTypes.string,
  color:PropTypes.string
};

export default Editor;